module.exports = __webpack_public_path__ + "static/media/bg_hero_v2.ed147db0.svg";